<template>
  <div class="wrp">
    <div class="back">
      <span @click="goback"><i class="el-icon-back"></i>Back</span>
    </div>
    <div class="bgd">
      <div class="con">
        <h1>Edit Venue</h1>
       
        <h2><i style="font-style:normal;color:#fff">*</i> Venue Name</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['name']}" @blur="validateInput('name')" type="text" v-model="name" maxlength="50" @input="validateComplete" @change="validateComplete" />
        </div>
        <h2> Main / Parent Venue</h2>
        <div class="inputItem">
          <el-select
            v-model="parentId"
            :disabled="isParent"
            filterable
            :default-first-option="true"
            class="select-input"
            placeholder="Select"
            @input="validateComplete" 
            @change="validateComplete"
          >
            <el-option
              v-for="item in parentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Venue Owner</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['owner']}" @blur="validateInput('owner')" type="text" v-model="owner" @input="validateComplete" maxlength="50" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Contact Number</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['number']}" @blur="validateInput('number')" type="text" v-model="number" @input="validate('number')" maxlength="10" @change="validateComplete" />
        </div>

        <h2>  <!--<i style="font-style:normal;color:#fff">*</i>  --> ABN</h2>
        <div class="inputItem" style="position:relative">
          <span v-if="warn" style="position:absolute;left:0;top:55px;color:rgb(242 0 20);font-size:12px">Please enter an 11-digit ABN</span>
          <input type="text" @blur="validateInput('abn')" :style="{'border-color': warn ? 'rgb(242 0 20)' : '#5f5f5f'}" v-model="abn" @input="validate('abn')" maxlength="11" @change="validateComplete" />
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Venue Description</h2>
        <div class="checkboxItem clear">
          <el-checkbox-group v-model="check" @change="cheboxChange">
            <el-checkbox label="Bar"></el-checkbox>
            <el-checkbox label="Café"></el-checkbox>
            <el-checkbox label="Restaurant"></el-checkbox>
          </el-checkbox-group>
          <el-select v-model="slt" v-if="sltShow">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Cuisine Type</h2>
        <div class="typeItem clear">
          <div class="add" @click="openCuisine">
            <i class="el-icon-circle-plus-outline"></i>
            Add Type
          </div>
          <div class="item" v-for="item in typeList" :key="item">{{item}}<i @click="removeCurrent(item)"></i></div>
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Venue Address</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['address']}" @blur="validateInput('address')" type="text" v-model="address" @input="validateComplete" maxlength="100" />
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <h2><i style="font-style:normal;color:#fff">*</i> Venue Timezone</h2>
            <div class="inputItem">
              <el-select
                v-model="timezone"
                filterable
                :default-first-option="true"
                class="select-input"
                placeholder="Select"
                @input="validateComplete" 
                @change="validateComplete"
              >
                <el-option
                  v-for="item in timezoneList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <h2><i style="font-style:normal;color:#fff">*</i> GST Rate %</h2>
            <div class="inputItem">
              <input type="number" v-model="gstRate" @input="validateInput('gstRate')"  :min="1" :max="100" :step="1" />
            </div>
          </el-col>
        </el-row>

        <h2>Max allowed emails in automated report:</h2>
        <div class="inputItem">
          <input type="text" v-model="maxAutomatedEmails" maxlength="100" :readonly="IS_ENABLE_EDIT_PERIODIC_EMAILS"/>
        </div>
        <h2>Website</h2>
        <div class="inputItem">
          <input type="text" v-model="web" maxlength="100" />
        </div>
        <h2>Instagram Username</h2>
        <div class="inputItem">
          <input type="text" v-model="ins" maxlength="100" />
        </div>
        <h2>Facebook Page</h2>
        <div class="inputItem">
          <input type="text" v-model="face" maxlength="100" />
        </div>
        <template v-if="!isHideFields">
          <h2> Lease End Date</h2>
          <div class="dateItem">
            <el-date-picker
              style="opacity:0;z-index:1"
              @change="validateComplete($event, 'date')"
              v-model="date"
              type="date"
              format="dd/MM/yyyy"
              :editable="false"
              :clearable="false"
              placeholder="">
            </el-date-picker>
            <div style="position: absolute;
            left: 60px;
            top: 0;
            line-height: 50px;
            font-size: 18px;color:#fff">{{showDate}}</div>
          </div>
        </template>
        <template v-if="!isHideFields">
          <h2>Does the Rental Agreement include outgoings?</h2>
          <div class="radioItem clear">
            <div class="radio">
              <el-radio v-model="boo" label="1">Yes</el-radio>
            </div>
            <div class="radio">
              <el-radio v-model="boo" label="2">No</el-radio>
            </div>
          </div>
          <div class="new_box">
            <div class="inputItem inputItemNew prefix-customize">
              <h2>Monthly Rental Cost</h2>
              <el-input prefix-icon="$" type="text" v-model="cost" @input="validate('cost')" maxlength="13" @change="validateComplete" />
              <!--<span class="lft">$</span>-->
            </div>
            <div class="inputItem prefix-customize">
              <h2>Annual Rental Cost</h2>
              <el-input prefix-icon="$" type="text" v-model="cost1" @input="validate('cost1')" maxlength="13" @change="validateComplete" />
              <!--<span class="lft">$</span>-->
            </div>
          </div>
          <h2>Yearly Rental Increase In % Or $ Value</h2>
          <div class="radioItem clear">
            <div class="radio input suffix-customize">
              <el-radio v-model="boo2" label="1" @change="radioChange"></el-radio>
              <el-input suffix-icon="%" type="text" :disabled="boo2 === '1' ? false : true" :style="{'cursor': boo2 === '1' ? 'pointer' : 'not-allowed'}" v-model="percentage" maxlength="5" @input="validate('percentage')" @change="validateComplete" />
            </div>
            <div class="radio input prefix-customize">
              <el-radio v-model="boo2" label="2" @change="radioChange"></el-radio>
              <el-input prefix-icon="$" type="text" :disabled="boo2 === '2' ? false : true" :style="{'cursor': boo2 === '2' ? 'pointer' : 'not-allowed'}" v-model="dollar" maxlength="5" @input="validate('dollar')" @change="validateComplete" />
            </div>
          </div>
          <h2>Yearly Rental Increase Date</h2>
          <!--<div class="dateItem">
            <el-date-picker
              style="opacity:0;z-index:1"
              @change="validateComplete($event, 'time')"
              v-model="time"
              type="date"
              format="dd/MM/yyyy"
              :editable="false"
              :clearable="false"
              placeholder="">
            </el-date-picker>
            <div style="position: absolute;
            left: 60px;
            top: 0;
            line-height: 50px;
            font-size: 18px;color:#fff">{{showTime}}</div>
          </div>-->
          <div class="monItem">
            <el-cascader @change="validateComplete($event, 'time')" style="opacity:0;z-index:1" :options="dateOptions" separator=" " placeholder="" v-model="time"></el-cascader>
            <div style="position: absolute;
            left: 60px;
            top: 0;
            line-height: 50px;
            font-size: 18px;color:#fff">{{showTime}}</div>
          </div>
          <h2>Rent Free Period</h2>
          <div class="inputItem suffix-months-customize">
            <el-input type="text" suffix-icon="months" v-model="period" maxlength="10" @input="validate('period')" />
          </div>
          <h2>Additional Amount</h2>
          <div class="inputItem prefix-customize">
            <el-input prefix-icon="$" type="text" v-model="amount" maxlength="10" @input="validate('amount')" />
            <!--<span class="lft">$</span>-->
          </div>
        </template>
        <h2>Card Number</h2>
        <div class="inputItem">
          <input type="text" v-model="card" maxlength="16" @input="validate('card')"
          @blur="validateCardFormat" :readonly="true"/>
        </div>
        <h2>Full Name</h2>
        <div class="inputItem">
          <input type="text" v-model="full" maxlength="40" :readonly="true"/>
        </div>
        <div class="doubleInputItem clear">
          <div class="singleItem">
            <h2>Expire</h2>
            <div class="inputItem" style="border:1px solid #5f5f5f;box-sizing:border-box;background:#151C27;">
              <input type="text" ref="month" v-model="expirem" style="border:none;width:150px;padding:0 0 0 15px;text-align:right" maxlength="2" @input="validate('expirem')" /> /
              <input type="text" ref="year" @keyup="nextFocus1($event)"
              v-model="expirey" style="border:none;width:150px;padding:0" maxlength="2" @input="detectY()" :readonly="true"/>
            </div>
          </div>
          <div class="singleItem">
            <h2>CVV</h2>
            <div class="inputItem">
              <input type="text" v-model="cvv" :maxlength="cvvLength" @input="detectCvv()"
              @blur="validateCardFormat" :readonly="true"/>
            </div>
          </div>
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i> Monthly Fee</h2>
        <div class="inputItem prefix-customize">
          <el-input :class="{'border-error': validationInputError['fee']}" @blur="validateInput('fee')" prefix-icon="$" type="text" v-model="fee" maxlength="10" @input="validate('fee')" @change="validateComplete" />
          <!--<span class="lft">$</span>-->
        </div>
        <h2>Opening Hours</h2>
        <div class="edit-table" style="margin-bottom:30px">
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
              prop="week"
              label="WEEK"
              width="130"
              class-name="alignCenter">
            </el-table-column>
            <el-table-column
              label="TIME"
              width="448">
              <template slot-scope="scope">
                <span v-if="scope.row.time">{{scope.row.time}}</span>
                <span v-else>Closed</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Operation"
              width="160"
              class-name="alignCenter">
              <template slot-scope="scope">
                <div class="btns clear">
                  <div class="add" @click="addTime(scope.row)">Add</div>
                  <div class="reset" @click="resetTime(scope.$index)">Reset</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h2><i style="font-style:normal;color:#fff">*</i>Username</h2>
        <div class="inputItem">
          <input :class="{'border-error': validationInputError['username']}" @blur="validateInput('username')" @input="validateComplete" type="text" v-model="username" maxlength="30" />
        </div>
        <div class="btm-btns clear">
          <button class="cancel" @click="goback">Cancel</button>
          <button class="confirm" :class="{'disabled': !isComplete}" :disabled="!isComplete" @click="confirm">Confirm</button>
        </div>
      </div>
    </div>

    <timePicker v-if="addTimeDio" :addTimeDio="addTimeDio" @cancel="addTimeDio=false" @add="addTimed"></timePicker>

    <transition name="fade" v-if="pop">
      <cuisine @eventCacncel="closeCuisine" @eventConfirm="getCuisinetype" :checked="typeString"></cuisine>
    </transition>

  </div>
</template>

<script>
import api from '../../api/account'
import timePicker from '../common/timepicker.vue'
import cuisine from '../common/cuisine.vue'

export default {
  data () {
    return {
      dateOptions: [{ // test
          value: '01',
          label: 'Jan',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '02',
          label: 'Feb',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }]
      }, {
          value: '03',
          label: 'Mar',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '04',
          label: 'Apr',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '05',
          label: 'May',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '06',
          label: 'June',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '07',
          label: 'Jul',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '08',
          label: 'Aug',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '09',
          label: 'Sept',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '10',
          label: 'Oct',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '11',
          label: 'Nov',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '12',
          label: 'Dec',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }],
      isParent: true,
      parentId: null,
      parentOptions: [],
      venueId: '',
      name: '',
      owner: '',
      number: '',
      abn: '',
      warn: false,
      // Venue Description
      check: [],
      // Cuisine Type
      typeList: [],
      typeString: '',
      address: '',
      web: '',
      ins: '',
      face: '',
      date: null,
      showDate: null,
      // Does the Rental Agreement include outgoings
      boo: null,
      // Yearly Rental Increase In % Or $ Value
      boo2: null,
      percentage: '',
      dollar: '',

      // Monthly Rental Cost
      cost: '',
      cost1: '',
      // 选中的日期
      time: null,
      showTime: null,
      period: '',
      amount: '',
      card: '',
      cardInitial: '',
      full: '',
      expirem: '',
      expiremInitial: '',
      expirey: '',
      expireyInitial: '',
      cvv: '',
      cvvInitial: '',
      cvvLength: 4,
      isCardFormRight: true,
      fee: '',
      username: '',
      timezone: '',
      gstRate: '',
      timezoneList: [],
      // 选中的时间段数据
      tableData: [],
      // 选时间段的操作
      addTimeDio: false,
      // Venue Description是否显示下拉框
      sltShow: false,
      // Venue Description选的下拉框
      slt: 'Fast Food',
      options: [{
        value: 'Fast Food',
        label: 'Fast Food'
      }, {
        value: 'Quick Service',
        label: 'Quick Service'
      }, {
        value: 'Fast Casual',
        label: 'Fast Casual'
      }, {
        value: 'Fine Dining ',
        label: 'Fine Dining '
      }],
      // 是否打开选择的弹窗
      pop: false,
      // 是否输入完整
      isComplete: true,
      changed: false,

      validationInputError: {
        id: false,
        name: false,
        owner: false,
        number: false,
        address: false,
        fee: false,
        username: false,
        password: false,
        gstRate: false
      },
      maxAutomatedEmails: null,
      IS_ENABLE_EDIT_PERIODIC_EMAILS: process.env.IS_ENABLE_EDIT_PERIODIC_EMAILS == '1' ? false : true,
      isAlreadyHaveCard: false,
      isHideFields: true
    }
  },
  created () {
    api.venueAccntDetail({
      params: parseInt(this.$route.params.id),
      callback: this.callback
    })
  },
  watch: {
    timezone(timezone) {
      if (!this.gstRate || this.gstRate === '' || this.gstRate === null || this.gstRate === undefined) {
        if (timezone.includes('Australia')) {
          this.gstRate = 10
        } else {
          this.gstRate = 15
        }
      }
     
    }
  },
  methods: {

    validateInput(modelName) {
      const model = typeof(this[modelName]) === 'number' ? JSON.stringify(this[modelName]) : this[modelName];
      if (model.replace(/\s+/g,'') === '') {
        this.validationInputError[modelName] = true;
      } else {
        this.validationInputError[modelName] = false;
      }
    },

    detectCvv() {
        if (((this.card !== this.cardInitial) ||
            (this.expirey !== this.expireynitial) ||
            (this.expirem !== this.expireymInitial) ||
            (this.cvv !== this.cvvInitial)) &&
            !this.changed && !this.showAdd){
            this.card = ''
            this.cvv = ''
            this.expirey = ''
            this.expirem = ''
            this.changed = true
            return
        }
        this.cvv = this.cvv.replace(/[^\d]/g,'')
        this.changed = true
    },
    detectY() {
        if (((this.card !== this.cardInitial) ||
            (this.expirey !== this.expireynitial) ||
            (this.expirem !== this.expireymInitial) ||
            (this.cvv !== this.cvvInitial)) &&
            !this.changed && !this.showAdd){
            this.card = ''
            this.cvv = ''
            this.expirey = ''
            this.expirem = ''
            this.changed = true
            return
        }
        this.expirey = this.expirey.replace(/[^\d]/g,'')
        this.changed = true
    },
    validateCardFormat() {
      if ((this.card.length === 15 && this.cvv.length === 4) || (this.card.length === 16 && this.cvv.length === 3)){
        this.isCardFormRight = true
      } else if (this.card.length > 0 && this.cvv.length > 0){
        this.isCardFormRight = false
        // Utils.alert('', 'Please enter the correct credit card format', 'error')
      } else if (this.card.length === 0 && this.cvv.length === 0) {
        this.isCardFormRight = true
      } else {
        this.isCardFormRight = false
      }
    },
    nextFocus1 (el) {
      if (el.keyCode == 8 && this.expirey == '')
        this.$refs.month.focus()
    },
    radioChange() {
      this.validateComplete()
      if (this.boo2 === '1')
        this.dollar = ''
      else
        this.percentage = ''
    },
    goback () {
      this.$router.go(-1)
    },
    addTime(val){
      this.addTimeDay=val.week
      this.addTimeDio=true
    },
    resetTime(e) {
      this.tableData[e].time = ''
    },
    addTimed(val){
      /*this.tableData.forEach(item=>{
          if(item.week == this.addTimeDay){
            if(item.time !== '') {
              let arr = item.time.split(',')
              arr.push(val)
              item.time = arr.join(',')
            } else {
              item.time = val
            }
          }
      })
      this.addTimeDio = false
      this.validateComplete()*/
      // 找到对应的星期，设置时间，获取为设置的天数
      let num = 0
      let temp = ''
      this.tableData.forEach(item=>{
          if(item.week == this.addTimeDay){
            if(item.time !== '') {
              let arr = item.time.split(',')
              arr.push(val)
              item.time = arr.join(',')
            } else {
              item.time = val
            }
            temp = item.time
          } else {
            if (item.time === '')
              num ++
          }
      })
      // 重新遍历一次
      if (num === 6) {
        this.tableData.forEach(item => {
          if (item.time === '') {
            item.time = temp
          }
        })
      }
      this.addTimeDio = false
      this.validateComplete()
    },
    // 多选框变化选中
    cheboxChange (val) {
      if (val.includes('Restaurant')) {
        this.sltShow = true
      } else {
        this.sltShow = false
      }
      this.validateComplete()
    },
    // 移除type
    removeCurrent (name) {
      var that = this
      that.typeList.find((v, i) => {
        if (v == name) {
          that.typeList.splice(i, 1)
          that.validateComplete()
        }
      })
    },
    // 新增type，打开弹窗，并把现有的type传过去
    openCuisine () {
      var that = this
      that.pop = true
      if (that.typeList.length > 0) {
        that.typeString = that.typeList.join(',')
      }
    },
    // 取消新增
    closeCuisine () {
      this.pop = false
    },
    // 拿到新增的type，关闭弹窗
    getCuisinetype (type) {
      var that = this
      that.pop = false
      if (type == '') {
        that.typeList = []
        that.typeString = ''
        this.validateComplete()
        return
      }
      const addLst = type.split(',')
      that.typeList = addLst
      that.typeString = that.typeList.join(',')
      this.validateComplete()
    },
    validate (type) {
      var that = this
      if (type === 'number') {
        this.number = this.number.replace(/[^\d]/g,'')
        that.validateComplete()
      } else if (type === 'abn') {
        // this.abn = this.abn.replace(/[^\d]/g,'')
        // that.validateComplete()
      } else if (type === 'cost') {
        this.cost = this.cost.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.cost1 = this.$box.formatDecimal2(this.cost * 12,2)
        that.validateComplete()
      } else if (type === 'cost1') {
        this.cost1 = this.cost1.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.cost = this.$box.formatDecimal2(this.cost1 / 12,2)
        that.validateComplete()
      }else if (type === 'percentage') {
        this.percentage = this.percentage.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        if (this.percentage === '100.') {
          this.percentage = '100'
        }
        if (parseFloat(this.percentage) > 100) {
          this.percentage = '100'
        }
        that.validateComplete()
      } else if (type === 'dollar') {
        this.dollar = this.dollar.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        that.validateComplete()
      } else if (type === 'period') {
        this.period = this.period.replace(/[^\d]/g,'')
      } else if (type === 'amount') {
        this.amount = this.amount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
      } else if (type === 'card') {
        if (((this.card !== this.cardInitial) ||
            (this.expirey !== this.expireynitial) ||
            (this.expirem !== this.expireymInitial) ||
            (this.cvv !== this.cvvInitial)) &&
            !this.changed && !this.showAdd){
            this.card = ''
            this.cvv = ''
            this.expirey = ''
            this.expirem = ''
            this.changed = true
            return
        }
        this.card = this.card.replace(/[^\d]/g,'')
        this.changed = true
        if (this.card.length < 16)
          this.cvvLength = 4
        else
          this.cvvLength = 3

      } else if (type === 'fee') {
        this.fee = this.fee.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        that.validateComplete()
      } else if (type === 'expirem') {
        if (((this.card !== this.cardInitial) ||
            (this.expirey !== this.expireynitial) ||
            (this.expirem !== this.expireymInitial) ||
            (this.cvv !== this.cvvInitial)) &&
            !this.changed && !this.showAdd){
            this.card = ''
            this.cvv = ''
            this.expirey = ''
            this.expirem = ''
            this.changed = true
            return
        }
        this.changed = true
        this.expirem = this.expirem.replace(/[^\d]/g,'')
        if (parseInt(this.expirem) > 12) {
          this.expirem = this.expirem.slice(0, 1)
        } else {
          if (this.expirem.length === 2)
            this.$refs.year.focus()
        }
      }
    },
    validateComplete(e, type) {
      
      this.cost = typeof(this.cost) === 'number' ? JSON.stringify(this.cost) : this.cost
      this.cost1 = typeof(this.cost1) === 'number' ? JSON.stringify(this.cost1) : this.cost1

      if (this.name.replace(/\s+/g,'') !== '' &&
        this.owner.replace(/\s+/g,'') !== '' &&
        this.number.replace(/\s+/g,'') !== '' &&
        this.timezone !== '' &&
        this.gstRate !== '' &&
        this.check.length !== 0 &&
        this.typeList.length !== 0 &&
        this.address.replace(/\s+/g,'') !== '' &&
        this.fee.replace(/\s+/g,'') !== '' &&
        this.username.replace(/\s+/g,'') !== '') {
        this.isComplete = true
      } else {
        this.isComplete = false
      }

      if (this.timezone && (this.gstRate === '' || this.gstRate === null)) {
        if (this.timezone.includes('Australia')) {
            this.gstRate = 10
        } else {
            this.gstRate = 15
        }
      }

      if (type === 'date') {
        let a = (new Date(e)).getTime()
        this.showDate = Utils.formatdateminute(a)
      }
      if (type === 'time') {
        let M = this.time[0]
        if (M === '01') {
          M = 'Jan'
        } else if (M === '02') {
          M = 'Feb'
        } else if (M === '03') {
          M = 'Mar'
        } else if (M === '04') {
          M = 'Apr'
        } else if (M === '05') {
          M = 'May'
        } else if (M === '06') {
          M = 'Jun'
        } else if (M === '07') {
          M = 'Jul'
        } else if (M === '08') {
          M = 'Aug'
        } else if (M === '09') {
          M = 'Sep'
        } else if (M === '10') {
          M = 'Oct'
        } else if (M === '11') {
          M = 'Nov'
        } else if (M === '12') {
          M = 'Dec'
        }
        this.showTime = this.time[1] + ' ' + M
      }
    },
    tableFilter() {
      let result = false
      this.tableData.map(item => {
        if (item.time !== '') {
          result = true
        }
      })
      return result
    },
    rentalFilter() {
      let result = false
      if (this.boo2 == '1' && this.percentage !== '') {
        result = true
      }
      if (this.boo2 == '2' && this.dollar !== '') {
        result = true
      }
      return result
    },
    confirm() {
      let timeList = []
      this.tableData.forEach(item => {
        if (item.week === 'Mon') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Monday'
          }
          timeList.push(obj)
        } else if (item.week === 'Tues') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Tuesday'
          }
          timeList.push(obj)
        } else if (item.week === 'Thu') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Thursday'
          }
          timeList.push(obj)
        } else if (item.week === 'Fri') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Friday'
          }
          timeList.push(obj)
        } else if (item.week === 'Sat') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Saturday'
          }
          timeList.push(obj)
        } else if (item.week === 'Sun') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Sunday'
          }
          timeList.push(obj)
        } else if (item.week === 'Wed') {
          const obj = {
            openTime: item.time === '' ? null : item.time,
            week: 'Wednesday'
          }
          timeList.push(obj)
        }
      })
      let leaseEndDate = ''
      if (this.date !== '' && this.date !== null)
        leaseEndDate = ((new Date(this.date)).getTime()) / 1000
      let yearlyRentalIncreaseDate = ''
      if (this.time !== null && this.time !== '')
        yearlyRentalIncreaseDate = this.time[0] + '-' + this.time[1]
      let arr = []
      this.check.forEach(item => {
        if (item === 'Bar') {
          arr.push('Bar')
        } else if (item === 'Café') {
          arr.push('Cafe')
        } else if (item === 'Restaurant') {
          arr.push(this.slt)
        }
      })
      const venueDescription = arr.join(',')
      let request_params = {
        id: parseInt(this.$route.params.id),
        parentId: this.parentId,
        abn: this.abn, // 必填
        additionalAmount: !this.amount || this.amount === '' ? null : (typeof(this.amount) === 'string' ? Number(this.amount) : this.amount),
        cardName: this.full === '' ? null : this.full,
        cardNumber: this.changed ? this.card : this.cardInitial, // 必填
        cuisineType: this.typeList.join(','), // 必填
        cvv: this.changed ? this.cvv : this.cvvInitial,
        expire: this.changed ? `${this.expirem}/${this.expirey}` : `${this.expiremInitial}/${this.expireyInitial}`,
        // expire: this.expirem !== '' && this.expirey !== '' ? this.expirem + '/' + this.expirey : null,
        facebookPage: this.face === '' ? null : this.face,
        instagramUsername: this.ins === '' ? null : this.ins,
        leaseEndDate: leaseEndDate !== '' ? leaseEndDate : null,
        monthlyFee: this.fee.indexOf('.') == -1 ? parseInt(this.fee) : parseFloat(this.fee), // 必填
        monthlyRentalCost: this.cost !== '' ? (typeof(this.cost) === 'string' ? Number(this.cost) : this.cost) : null, // 必填
        yearRentalCost: this.cost1 !== '' ? (typeof(this.cost1) === 'string' ? Number(this.cost1) : this.cost1) : null, // 必填
        venueAddress: this.address, // 必填
        timezone: this.timezone,
        gstRate: (this.gstRate / 100),
        venueDescription: venueDescription, // 必填
        venueMobile: this.number, // 必填
        venueName: this.name, // 必填
        venueOpenUpdateVoList: timeList,
        venueOwner: this.owner, // 必填
        website: this.web === '' ? null : this.web,
        includeOutgoings: this.boo === null ? null : (this.boo === '1' ? 1 : 0),
        rentFreePeriod: this.period,
        // yearlyRentalIncrease: this.boo2 === '1' ? parseFloat(this.percentage) : parseFloat(this.dollar), // 必填
        yearlyRentalIncreaseDate: yearlyRentalIncreaseDate === '' ? null : yearlyRentalIncreaseDate, // 必填
        // yearlyRentalIncreaseType: this.boo2 === '1' ? 1 : 0 // 必填

        userName: this.username,
        maxAutomatedEmails: this.maxAutomatedEmails
      }
      request_params.expire = request_params.expire === '/' ? '' : request_params.expire
      if (this.boo2 !== null && this.boo2 !== '') {
        if (this.boo2 === '1') {
          if (this.percentage === '') {
            request_params.yearlyRentalIncreaseType = 1
            request_params.yearlyRentalIncrease = 0
          } else {
            request_params.yearlyRentalIncreaseType = 1
            request_params.yearlyRentalIncrease = parseFloat(this.percentage)
          }
        } else {
          if (this.dollar === '') {
            request_params.yearlyRentalIncreaseType = 0
            request_params.yearlyRentalIncrease = 0
          } else {
            request_params.yearlyRentalIncreaseType = 0
            request_params.yearlyRentalIncrease = parseFloat(this.dollar)
          }
        }
      }
      this.$box.loadings()
      api.edtAnt({
        params: request_params,
        callback: this.edtCallback
      })
    },
    edtCallback(res) {
      console.log('res: ', res);
      var that = this
      that.$box.loadings(2)
      if(res.data && res.data.code == 0){
        that.$router.go(-1)
      } else{
        if (res.response) {
          Utils.alert('', res.response.data.message, 'error')
        } else {
          Utils.alert('', res.data.message, 'error')
        }
      }
    },
    callback(res) {
      var that = this
      if(res.data.code == 0){
        this.venueId = res.data.data.id;
        this.isParent = res.data.data.isParent;
        this.name = res.data.data.venueName
        this.owner = res.data.data.venueOwner
        this.number = res.data.data.venueMobile
        this.abn = res.data.data.abn

        if (res.data.data.parentId) {
          this.parentId = res.data.data.parentId;
        }

        if (res.data.data.gstRate) {
          this.gstRate = (res.data.data.gstRate * 100)
        }

        if (res.data.data.venueDescription) {
          if (res.data.data.venueDescription.indexOf(',') !== -1) {
            res.data.data.venueDescription.split(',').forEach(item => {
              if (item === 'Café' || item === 'Cafe'){
                this.check.push('Café')
              } else if (item === 'Bar'){
                this.check.push(item)
              } else {
                this.sltShow = true
                this.slt = item
                this.check.push('Restaurant')
              }
            })
          } else if (res.data.data.venueDescription.indexOf(',') === -1 && res.data.data.venueDescription.length > 0) {
            if (res.data.data.venueDescription === 'Café' || res.data.data.venueDescription === 'Cafe'){
              this.check.push('Café')
            } else if (res.data.data.venueDescription === 'Bar'){
              this.check.push(res.data.data.venueDescription)
            } else {
              this.sltShow = true
              this.slt = res.data.data.venueDescription
              this.check.push('Restaurant')
            }
          }
        }
        this.typeList = res.data.data.cuisineType.indexOf(',') !== -1 ? res.data.data.cuisineType.split(',') : [res.data.data.cuisineType]
        this.typeString = res.data.data.cuisineType
        this.address = res.data.data.venueAddress
        this.timezone = res.data.data.timezone
        this.web = res.data.data.website
        this.ins = res.data.data.instagramUsername
        this.face = res.data.data.facebookPage
        if (res.data.data.leaseEndDate !== null && res.data.data.leaseEndDate !== '')
            this.date = res.data.data.leaseEndDate * 1000
        this.showDate = Utils.formatdateminute(this.date)
        if (res.data.data.includeOutgoings !== null && res.data.data.includeOutgoings !== '')
            this.boo = res.data.data.includeOutgoings === 1 ? '1' : '2'
        if (res.data.data.yearlyRentalIncreaseType !== null && res.data.data.yearlyRentalIncreaseType !== '')
            this.boo2 = res.data.data.yearlyRentalIncreaseType === 1 ? '1' : '2'
        this.percentage = res.data.data.yearlyRentalIncreaseType === 1 ? res.data.data.yearlyRentalIncrease : ''
        this.dollar = res.data.data.yearlyRentalIncreaseType === 1 ? '' : res.data.data.yearlyRentalIncrease
        this.cost = res.data.data.monthlyRentalCost !== null ? JSON.stringify(res.data.data.monthlyRentalCost) : res.data.data.monthlyRentalCost
        this.cost1 = res.data.data.yearRentalCost !== null ? JSON.stringify(res.data.data.yearRentalCost) : res.data.data.yearRentalCost
        this.username = res.data.data.userName
        this.maxAutomatedEmails = res.data.data.maxAutomatedEmails ? res.data.data.maxAutomatedEmails : 5
        if (res.data.data.yearlyRentalIncreaseDate && res.data.data.yearlyRentalIncreaseDate !== '' && typeof(res.data.data.yearlyRentalIncreaseDate) === 'string' && res.data.data.yearlyRentalIncreaseDate.indexOf('-') !== -1) {
          this.time = res.data.data.yearlyRentalIncreaseDate.split('-')
          let M = this.time[0]
          if (M === '01') {
            M = 'Jan'
          } else if (M === '02') {
            M = 'Feb'
          } else if (M === '03') {
            M = 'Mar'
          } else if (M === '04') {
            M = 'Apr'
          } else if (M === '05') {
            M = 'May'
          } else if (M === '06') {
            M = 'Jun'
          } else if (M === '07') {
            M = 'Jul'
          } else if (M === '08') {
            M = 'Aug'
          } else if (M === '09') {
            M = 'Sep'
          } else if (M === '10') {
            M = 'Oct'
          } else if (M === '11') {
            M = 'Nov'
          } else if (M === '12') {
            M = 'Dec'
          }
          this.showTime = this.time[1] + ' ' + M
        }/* else {
          this.isComplete = false
        }*/
        this.period = res.data.data.rentFreePeriod
        this.amount = res.data.data.additionalAmount !== null ? JSON.stringify(res.data.data.additionalAmount) : res.data.data.additionalAmount
        this.card = res.data.data.cardNumber ? res.data.data.cardNumber : ''
        this.cardInitial = res.data.data.cardNumber ? res.data.data.cardNumber : ''
        this.full = res.data.data.cardName
        this.expirem = res.data.data.expire !== null && res.data.data.expire.indexOf('/') !== -1 ? res.data.data.expire.split('/')[0] : ''
        this.expiremInitial = res.data.data.expire !== null && res.data.data.expire.indexOf('/') !== -1 ? res.data.data.expire.split('/')[0] : ''
        this.expirey = res.data.data.expire !== null && res.data.data.expire.indexOf('/') !== -1 ? res.data.data.expire.split('/')[1] : ''
        this.expireyInitial = res.data.data.expire !== null && res.data.data.expire.indexOf('/') !== -1 ? res.data.data.expire.split('/')[1] : ''
        this.cvv = res.data.data.cvv ? res.data.data.cvv : ''
        this.cvvInitial = res.data.data.cvv ? res.data.data.cvv : ''
        this.fee = res.data.data.monthlyFee !== null ? JSON.stringify(res.data.data.monthlyFee) : res.data.data.monthlyFee
        this.validateCardFormat()
        res.data.data.venueOpenList.forEach(item => {
          if (item.week === "Monday") {
            this.tableData.push({
              week: 'Mon', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Tuesday") {
            this.tableData.push({
              week: 'Tues', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Wednesday") {
            this.tableData.push({
              week: 'Wed', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Thursday") {
            this.tableData.push({
              week: 'Thu', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Friday") {
            this.tableData.push({
              week: 'Fri', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Saturday") {
            this.tableData.push({
              week: 'Sat', time: item.openTime === "Closed" ? '' : item.openTime
            })
          } else if (item.week === "Sunday") {
            this.tableData.push({
              week: 'Sun', time: item.openTime === "Closed" ? '' : item.openTime
            })
          }
        })

      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
  },

  async mounted() {
    api.getVenueWithParent({hasParent: false, callback: (res) => {
      if (res.data.code === 0) {
        this.parentOptions = res.data.data.list
          .filter(item => item.id !== parseInt(this.$route.params.id)) // exclude venue itself
          .sort((a, b) => a.name.localeCompare(b.name)) // sort alphabetically
          .map(item => ({
            value: item.id,
            label: `${item.name} - (${item.id})`
          }))

        // add no parent option
        this.parentOptions.unshift({value: null, label: 'No Parent'});
      }

    }})

    const timezones = await api.getTimezoneList();
    if (timezones && timezones.length > 0) {
      this.timezoneList = timezones.map(item => ({
        value: item,
        label: item
      }))
    }
  },
  components:{
    timePicker,
    cuisine
  }
}
</script>

<style lang="scss" scoped>
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .back{
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    margin-bottom: 56px;
    font-family: 'SFProText-Semibold';
    background: #212429;
    width: 100%;
    z-index: 4;
    height: 20px;
    span{
      display: inline-block;
      width: 100px;
      cursor: pointer;
      i{
        margin-right: 10px;
      }
    }
  }
  .bgd{
    width: 100%;
    background: #2B3444;
    padding: 50px 0 65px 0;
    margin-bottom: 50px;
    .con{
      width: 740px;
      margin: 0 auto;
      .btm-btns{
        width: 610px;
        margin: 65px auto 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: #2B3444;
          float: left;
          box-sizing: border-box;
          font-size: 26px;
          cursor: pointer;
        }
        .cancel{
          margin-right: 50px;
          border: 2px solid #FFFFFF;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #fff;
        }
        .confirm{
          border: 2px solid #EA3796;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #EA3796;
        }
        .disabled{
          border: 2px solid #8E3771;
          color: #8E3771;
          cursor: not-allowed;
        }
      }
      h1{
        font-family: 'PingFangSC-Semibold';
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .inputItem{
        width: 100%;
        margin-bottom: 30px;
        position: relative;
        .el-input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
          height: 50px;
        }
        input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
          height: 50px;
        }
        .lft{
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: #fff;
        }
        .rgt{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: #fff;
        }
      }
      .radioItem{
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 41px;
        .radio{
          width: 355px;
          float: left;
          position: relative;
        }
        .el-input{
          width: 318px;
          height: 50px;
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
        }
        input{
          width: 318px;
          height: 50px;
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: #151C27;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: #fff;
        }
        .radio:nth-child(1){
          margin-right: 30px;
          input{
            padding: 0 40px 0 15px;
          }
        }
        .radio:nth-child(2){
          input{
            padding: 0 15px 0 40px;
          }
        }
        .percentage{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: #fff;
        }
        .dollar{
          position: absolute;
          left: 56px;
          line-height: 50px;
          color: #fff;
        }
      }
      .dateItem{
        margin-bottom: 30px;
        position:relative;border-radius: 0;
        border: 1px solid #5f5f5f;
        background-color: #151C27;
        height: 50px;
        color: #fff;
        font-family: 'SFProText-Regular';
        font-size: 20px;
        color: #151c27;
        background-size: 23px 22px;
        background-position: 16px center;
        background-repeat: no-repeat;
        background-image: url('../../assets/c.png');
      }
      .monItem{
        margin-bottom: 30px;
        position:relative;border-radius: 0;
        border: 1px solid #5f5f5f;
        background-color: #151C27;
        height: 50px;
        color: #fff;
        font-family: 'SFProText-Regular';
        font-size: 20px;
        color: #151c27;
        background-size: 23px 22px;
        background-position: 16px center;
        background-repeat: no-repeat;
        background-image: url('../../assets/c.png');
      }
      .checkboxItem{
        margin-bottom: 44px;
      }
      .singleItem{
        width: 355px;
      }
      .singleItem:nth-child(1){
        float: left;
      }
      .singleItem:nth-child(2){
        float: right;
      }
      .typeItem{
        width: 100%;
        .add{
          float: left;
          width:150px;
          height:50px;
          border:1px solid rgba(234,55,150,1);
          line-height:50px;
          color: #EA3796;
          font-size: 20px;
          padding-left: 46px;
          box-sizing: border-box;
          position: relative;
          cursor: pointer;
          margin-right: 30px;
          margin-bottom: 30px;
          i{
            font-size: 20px;
            position: absolute;
            left: 16px;
            top: 15px;
          }
        }
        .item{
          height:50px;
          background:rgba(21,28,39,1);
          border:1px solid rgba(95,95,95,1);
          float: left;
          margin-right: 30px;
          padding: 0 20px;
          font-size: 20px;
          line-height: 50px;
          color: #fff;
          cursor: pointer;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 30px;
          i{
            display: block;
            width: 20px;
            height: 20px;
            position:absolute;
            right: -10px;
            top: -10px;
            cursor: pointer;
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
            background-image: url('../../assets/g.png');
          }
        }
      }
      .btns{
        width: 100%;
        box-sizing: border-box;
        padding-left: 16px;
        div{
          float: left;
          line-height: 60px;
          cursor: pointer;
        }
        .add{
          margin-right: 32px;
        }
        .reset{
          color: #EA3796;
        }
      }
      .timlst{
        width: 100%;
        span{
          display: block;
          float: left;
          line-height: 25px;
          i{
            font-style: normal;
          }
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .new_box{
    display: flex;
    .inputItem{
      flex: 1;
    }
    .inputItemNew{
      margin-right: 30px;
    }
  }

  .border-error {
    border-color: #f20014 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/edit.vue